import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Checkbox, Flex, HStack, Input, InputGroup, InputRightElement, Stack, Text, Spinner } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { explore, filterAttribute } from '../../constants/constants';
import FilterBody from './FilterBody';
// import Accordian from '../Accordion/Accordian';
import H3 from '../../Theme/Typography/H3';
import Accordian from '../Accordion/Accordian';
import { RiCloseCircleFill } from 'react-icons/ri';
import { BiSearch } from 'react-icons/bi';
export const FilterBox = ({
    setShowFilterBox,
    setApply,
    handleCheckboxChange,
    handleSearch,
    filteroptionData,
    filterOptions,
    searchTerm,
    filterCount,
    handleReset,
    className,
    position,
    marginRight,
    sort,
    maxH="160px",
    setSearchTerm,
    showSearch = false,
    loading: parentLoading
  }) => {

  const [accordianData,setAccordianData]=useState([]);
  const gates=["AND","OR","NOT"];
  const [internalLoading,setInternalLoading]=useState(true);

  const isLoading = parentLoading !== undefined ? parentLoading : internalLoading;

  function formatData() {
    return filteroptionData.map(element => {
      // hasMore/displayCount come from the backend's own facet cap (Algolia's
      // platform limit) - e.g. "1000+" instead of a bare "999", so the count
      // reads as a real lower bound rather than an arbitrary-looking number.
      const count = element?.hasMore && element?.displayCount ? element.displayCount : element?.value?.length;
      return {
        name: `${element.display} (${count})`,
        component: <FilterBody data={element.value ? element.value:''} Ukey={element.key} filterOptions={filterOptions} handleCheckboxChange={handleCheckboxChange} element={element} setApply={setApply}/>,
      };
    });
  }
  useEffect(()=>{
    if(filteroptionData){
      if(filteroptionData.length>0){
        const formattedData = formatData();
        setAccordianData(formattedData)
      } else {
        setAccordianData([]);
      }
      setInternalLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[filteroptionData,filterOptions])
  
    return (
      <Box 
        className={"box-filter-film"} 
        marginRight={marginRight && marginRight}
        borderRadius="md"
        boxShadow="sm"
        bg="white"
        position="relative"
      >
         <HStack className="mt-0" pt="5px" pr="5px" justifyContent={"flex-end"}>
            <RiCloseCircleFill
              size={"22px"}
              cursor="pointer"
              onClick={(e) => setShowFilterBox(false)}
            />
          </HStack>
        <Stack 
          pt="2" 
          px="4" 
          spacing={4}
          borderBottom="1px" 
          borderColor="gray.100"
        > 
          <HStack width="100%" spacing={3}>
            <Button
              color="white"
              onClick={() => {
                setApply((prev) => !prev);
                if (window.innerWidth <= 768) { 
                  setShowFilterBox(false);
                }
              }}
              width="full"
              height="40px"
              bg="color.primary"
              _hover={{ bg: 'color.primary', opacity: 0.9 }}
              fontSize="15px"
              fontWeight="500"
            >
              {explore.APPLY}
            </Button>

            <Button
              color="color.primary"
              onClick={() => {
                if((filterCount && filterCount>0) || filterOptions?.search!==''){
                  handleReset();
                  setApply((prev) => !prev);
                }
              }}
              width="full"
              height="40px"
              bg="gray.50"
              _hover={{ bg: 'gray.100' }}
              fontSize="15px"
              fontWeight="500"
            >
              {explore.RESET}
              {filterCount > 0 && (
                <Text as="span" ml={1} color="blue.500">
                  ({filterCount})
                </Text>
              )}
            </Button>
          </HStack>
        </Stack>
        {showSearch && (
          <HStack px="15px" alignItems={"left"} flexDirection={"column"}>
            <InputGroup borderColor={"#bdbdbd"} className="ml-0" py="2">
              <Input
                placeholder={explore.SEARCH}
                _placeholder={{ color: "#6d6d6d", fontSize: "15px", lineHeight: "20px" }}
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (searchTerm) {
                      handleCheckboxChange("searches", searchTerm);
                    }
                    setApply((prev) => !prev);
                    // setShowFilterBox(false);
                  }
                }
                }
              />
              <InputRightElement top={"auto"}>
                {searchTerm && searchTerm.length > 0 ? (
                  <RiCloseCircleFill
                    size={"20px"}
                    color="#999"
                    cursor="pointer"
                    onClick={() => {
                      setSearchTerm("");
                      handleCheckboxChange("searches", "");
                      setApply((prev) => !prev);
                    }}
                  />
                ) : (
                  <BiSearch
                    color="green.500"
                    cursor="pointer"
                    onClick={() => {
                      handleCheckboxChange("searches", searchTerm);
                      setApply((prev) => !prev);
                      setShowFilterBox(false);
                    }}
                  />
                )}
              </InputRightElement>
            </InputGroup>
          </HStack>
        )}

        <Stack 
          px="0" 
          py="2" 
          maxH={{base:"530px", lg:"415px", '2xl':"545px"}} 
          className="bodyscrollbar" 
          overflowY="auto"
          spacing={0}
        >
          {sort && sort?.length > 0 && accordianData && accordianData.length > 0 && (
            <Accordion allowToggle>
              <AccordionItem 
                border="none" 
                // paddingInlineStart={"0px!important"} 
                // paddingInlineEnd={"0px!important"}
              >
                <AccordionButton 
                  py={1}
                  px={4}
                  _hover={{ bg: 'transparent' }}
                  borderBottom="1px solid"
                  borderColor="color.lightgray4"
                >
                  <Text
                    fontSize="16px"
                    fontWeight="700"
                    color="color.primary"
                    flex="1"
                    textAlign="left"
                  >
                    {filterAttribute.SORT_BY}
                  </Text>
                  <AccordionIcon width={{base:"26",md:"32px"}} height={{base:"26",md:"32px"}} />

                </AccordionButton>
                <Box 
                  maxH="200px" 
                  className="accordian-filter-body-scrollbar" 
                  overflowY="auto"
                  mt={2}
                >
                  <AccordionPanel px="0px" pb={4} className="px-0">
                    {sort?.length>0 &&
                      sort?.map((it, index) => {
                        return (
                          <Flex 
                            key={index}
                            borderBottom="1px solid"
                            borderBottomColor="color.lightgray4"
                            py={2}
                            alignItems="center"
                            _hover={{ bg: "color.lightgray6" }}
                            px={1}
                            borderRadius="md"
                            transition="background 0.2s"
                          >
                            <Checkbox
                              borderColor="color.primary"
                              _checked={{
                                "& .chakra-checkbox__control": {
                                  background: "color.primary",
                                  borderColor: "color.primary",
                                },
                              }}
                              iconColor="white"
                              cursor="pointer"
                              marginRight={2}
                              isChecked={filterOptions.sortBy_v===it?.key}
                              onChange={() => {
                                handleCheckboxChange("sort", it.key);
                              }}
                            />
                            <Box flex="1">
                              <Text 
                                fontSize="14px"
                                color="color.primary"
                                fontWeight="500"
                              >
                                {it.display}
                              </Text>
                            </Box>
                          </Flex>
                        );
                      })}
                  </AccordionPanel>
                </Box>
              </AccordionItem>
              {filterOptions?.gate && (
                <AccordionItem 
                  border="none" 
                  px="0"
                  mb={0}
                >
                  <AccordionButton 
                    py={1}
                    px={4}
                    _hover={{ bg: 'transparent' }}
                    borderBottom="1px solid"
                    borderColor="color.lightgray4"
                  >
                    <Text
                      fontSize="16px"
                      fontWeight="700"
                      color="color.primary"
                      flex="1"
                      textAlign="left"
                    >
                      {filterAttribute.GATE}
                    </Text>
                    <AccordionIcon width={{base:"26",md:"32px"}} height={{base:"26",md:"32px"}} />

                  </AccordionButton>
                  <Box 
                    maxH="200px" 
                    className="accordian-filter-body-scrollbar" 
                    overflowY="auto"
                    mt={2}
                  >
                    <AccordionPanel px='0px' pb={4} className="px-1">
                      {gates?.length>0 &&
                        gates?.map((it, index) => {
                          return (
                            <Flex 
                              key={index}
                              borderBottom="1px solid"
                              borderBottomColor="color.lightgray4"
                              py={2}
                              alignItems="center"
                              _hover={{ bg: "color.lightgray6" }}
                              px={1}
                              borderRadius="md"
                              transition="background 0.2s"
                            >
                              <Checkbox
                                borderColor="color.primary"
                                _checked={{
                                  "& .chakra-checkbox__control": {
                                    background: "color.primary",
                                    borderColor: "color.primary",
                                  },
                                }}
                                iconColor="white"
                                cursor="pointer"
                                marginRight={2}
                                isChecked={filterOptions.gate===it}
                                onChange={() => {
                                  handleCheckboxChange("gate", it);
                                }}
                              />
                              <Box flex="1">
                                <Text 
                                  fontSize="14px"
                                  color="color.primary"
                                  fontWeight="500"
                                >
                                  {it}
                                </Text>
                              </Box>
                            </Flex>
                          );
                        })}
                    </AccordionPanel>
                  </Box>
                </AccordionItem>
              )}
            </Accordion>
          )}
          
         {isLoading ? (
            <HStack justifyContent={"center"} py="10">
              <Spinner size="xl" color="blue.500" thickness="4px" />
            </HStack>
          ) : accordianData && accordianData.length > 0 ? (
            <Accordian 
              data={accordianData}
              maxH={maxH}
              fontSize="14px"
            />
          ) : (
            <Box px="4" py="2">
              <H3>{explore.NO_FILTERS}</H3>
            </Box>
          )}
        </Stack>
      </Box>
    );
  };